import type {
  GameVisualProfile,
} from "./types";

export const truthOrDareVisualProfile:
GameVisualProfile = {
  id:
    "truth-or-dare",

  accents: {
    primary:
      "#9A4DFF",

    secondary:
      "#FF8A3D",
  },

  mechanicTones: {
    truth:
      "#9A4DFF",

    dare:
      "#FF8A3D",
  },
};
